import {Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter} from '@angular/core';

import {CDSNode, Rule, RuleCategory} from '../services/capd.model';
import {RulesService} from '../services/rules.service';
import {document} from "ngx-bootstrap/utils";
import {APIURL} from "../services/url.config";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {CDSTreeService} from "../services/cds.service";
import {Observable} from "rxjs";
import {ExportToCsv} from "export-to-csv";
import {OrgService} from "../services/org.service";
import {AlertService} from "../services/alert.service";

declare var $: any;
@Component({
  templateUrl: './rule.component.html',
})

export class LibraryComponent implements OnInit {
  @Input() listChange;
  selectedRule: Rule = null;
  relational: RuleCategory[];
  showAdd = false;
  private exportAllData: any[]
  generatingExport = false
  enabledOptions: string;
  requestedOidExport: string;
  @ViewChild('csvFileInput')
  csvFileInputVariable: ElementRef;

  @Output() ruleAddModal: EventEmitter<any> = new EventEmitter();
  newRule = {
    triggerName: null,
    triggerCategory: null,
    triggerCode: null,
    sqlExpression: null,
    renderEnvironment: 'Default',
    action: {messageTitle: null, actionType: 'Message', messageText: '', messagePriority: 'Normal'}
  };
  categories: string[];
  @Input() rules: Rule[];
  // Text variables!
  catText = 'Create new category';
  advText = 'Show advanced';
  catErrorText: string;
  ruleErrorText: string;
  codeErrorText: string;

  // We have so many booleans.
  catDropdown = true;
  ruleError = false;
  catError = false;
  codeError = false;
  advanced = false;

  settingList: any = [];
  selectedSetting = null;

  constructor(private _service: RulesService,
              private http: HttpClient,
              private _el: ElementRef,
              private _cdsService: CDSTreeService,
              private _org_service: OrgService,
              private alertService: AlertService
  ) {
  }


  /**
   * Hooks into the Angular life cycle to initialize the rule list.
   *
   * @func ngOnInit
   */
  ngOnInit() {
    this.updateList();
  }

  /**
   * Checks to see if the current user has the ability to edit packages.
   *
   * @func hasPackageManagement
   * @returns {boolean} true if the user has the package-management permission and false otherwise.
   */
  hasPackageManagement(): boolean {
    return sessionStorage.getItem('permissions').indexOf('package-management') > 0;
  }

  /**
   * Function called to both initialize and refresh the list of rules when any changes are made.
   *
   * @async
   * @func updateList
   * @param {string} ruleArg - if a specific rule has been changed, its ID is passed in to automatically
   *                           select it.
   */
  updateList(ruleArg?) {
    this._service.getRules().then((rules: Rule[]) => {
      this.rules = rules;
      this._service.getCategories().then((categories: string[]) => {
        categories = categories.sort(function (a, b) {
          return a.toLowerCase().localeCompare(b.toLowerCase());
        });
        this.categories = categories
        const rel = new Array(0);
        categories.forEach(category => {
          const subRules = rules.filter(rule => category === rule.triggerCategory);
          rel.push(new RuleCategory(category, subRules.sort((a, b) => {
            if(a.triggerName && b.triggerName)
              return a.triggerName.localeCompare(b.triggerName)
            else {
              if(a.triggerName)
                console.log("Identified problem with rule: " + b._id)
              else
                console.log("Identified problem with rule: " + a._id)
            }
          }), null));
        });
        this.relational = rel;
      });

    }).then(() => {
      if (ruleArg) {
        // this.selectedRule = rules.find(rule => rule._id === ruleArg);
        this.findRule(ruleArg.triggerCode, ruleArg.triggerName);
      } else {
        this.selectedRule = null;
      }
    });
  }

  /**
   * Selects a rule from the list.
   *
   * @func onSelect
   * @param {Rule} rule - the rule to select.
   */
  onSelect(rule: Rule) {
    this.selectedRule = rule;
  }

  showAddModal() {
    // get rules again in case new rules were added
    this._service.getRules().then((rules: Rule[]) => this.rules = rules);
    $(this._el.nativeElement).find('#modal-add-rule').show();
  }

  hideAddModal() {
    $(this._el.nativeElement).find('#modal-add-rule').hide();
  }

  /**
   * Simple toggle between selecting a category from a dropdown and writing in a new category.
   *
   * @func toggleCategoryAdd
   */
  toggleCategoryAdd() {
    this.catDropdown = !this.catDropdown;
    if (this.catDropdown) {
      this.catText = 'Create new category';
    } else {
      this.catText = 'Select category';
    }
  }

  /**
   * Simple toggle between entering a trigger code and entering a SQL query.
   *
   * @func toggleAdvanced
   */
  toggleAdvanced() {
    this.advanced = !this.advanced;
    if (this.advanced) {
      this.advText = 'Hide advanced';
    } else {
      this.advText = 'Show advanced';
    }
  }

  /**
   * Attempts to create the new rule given the parameters provided by the user.
   * Can error out for any number of reasons.
   *
   * @async
   * @func onSubmit
   */
  onSubmit() {
    $('.modal-backdrop').hide();
    // Reset error messages
    this.ruleError = false;
    this.catError = false;
    this.codeError = false;
    if (this.newRule.triggerName) {
      this.newRule.triggerName = this.newRule.triggerName.trim();
    }
    if (this.newRule.triggerCode) {
      this.newRule.triggerCode = this.newRule.triggerCode.trim();
    }
    if (this.newRule.triggerCategory) {
      this.newRule.triggerCategory = this.newRule.triggerCategory.trim();
    }
    if (this.newRule.action.messagePriority) {
      this.newRule.action.messagePriority = this.newRule.action.messagePriority.trim();
    }

    if (!this.newRule.triggerCategory || this.newRule.triggerCategory.length <= 0) {
      this.catErrorText = 'Category is required';
      this.catError = true;
    }

    if (!this.catDropdown) {
      // Check if added category exists
      if (this.categories.indexOf(this.newRule.triggerCategory) >= 0) {
        this.catErrorText = 'This category already exists';
        this.catError = true;
      }
    }
    // Now check if the rule exists
    if (!this.newRule.triggerName || this.newRule.triggerName.length <= 0) {
      this.ruleErrorText = 'Name is required';
      this.ruleError = true;
    }
    if (this.rules.filter(rule => this.newRule.triggerName === rule.triggerName).length > 0) {
      this.ruleErrorText = 'This rule already exists';
      this.ruleError = true;
    }
    if (!this.newRule.triggerCode || this.newRule.triggerCode.length <= 0) {
      this.codeError = true;
      this.codeErrorText = "Invalid trigger code";
    }
    if (this.rules.filter(rule => this.newRule.triggerCode === rule.triggerCode).length > 0) {
      this.codeError = true;
      this.codeErrorText = "Trigger code already exists.";

    }
    if (!this.catError && !this.ruleError && !this.codeError) {

      this.newRule.action.messageTitle = this.newRule.triggerName;
      this._service.addRule(this.newRule).then(addedRule => {
        this.ruleAddModal.emit(addedRule);
        $(this._el.nativeElement).find('#modal-add-rule').hide();
        this.updateList();
      }).then(() => {
        this.updateList(this.newRule)
      }).then(() => {
        this.onCancel()
      })
    }
  }

  // used to find a newly created rule in the list of rules
  // auto scrolls to this roll and sets it as selected rule
  async findRule(triggerCode, triggerName) {
    await this._service.getRules().then((rules: Rule[]) => {
      this.rules = rules;
      // get first instance of matching trigger code (there should only be one as trigger codes are now unique)
      let highlightedRule: Rule = rules.filter(rule => (rule.triggerCode == triggerCode) && (rule.triggerName == triggerName))[0]
      this.selectedRule = highlightedRule;
      return this.selectedRule
    }).then(rule => {
      // find the document element to scroll to
      // scroll into view
      let scrollto = document.getElementById('item' + rule.triggerName);
      try {
        scrollto.scrollIntoView();
      } catch (err) {
        console.log(err);
      }
      return rule
    })

  }

  /**
   * When the user cancels the action, reset all variables back to default and hide the modal.
   *
   * @func onCancel
   */
  onCancel() {
    this.newRule = {
      triggerName: null,
      triggerCategory: null,
      triggerCode: null,
      sqlExpression: null,
      renderEnvironment: 'Default',
      action: {messageTitle: null, actionType: 'Message', messageText: '', messagePriority: 'Normal'}
    };
    this.catText = 'Create new category';
    this.catDropdown = true;
    this.advText = 'Show advanced';
    this.advanced = false;

    this.ruleError = false;
    this.catError = false;
    this.codeError = false;

    this.hideAddModal();
  }

  // importRulesCsv(files: FileList) {
  //   let dotPosition = 0;
  //   if (files && files.length > 0) {
  //     let file: File = files.item(0);
  //     let checkCsv: string = file.name.toLowerCase();
  //     for (let i = checkCsv.length - 1; i >= 0; i--) {
  //       if (checkCsv.charAt(i) == '.') {
  //         dotPosition = i;
  //       }
  //     }
  //     if (checkCsv.substring(dotPosition, checkCsv.length) != '.csv') {
  //       this.alertService.showAlert("Please import a CSV file");
  //     } else {
  //       let csvArrayStructured = [];
  //       let foundTriggerCodes = [];
  //       papa.parse(file,  {
  //         header: true,
  //         complete: (result) => {
  //           if(result.errors.find(x => x.code == "TooManyFields")) {
  //             this.alertService.showAlert("Invalid CSV format!")
  //           } else if (result.data.length == 0) {
  //             this.alertService.showAlert("No records found in CSV!")
  //           } else {
  //             for (let i = 0; i < result.data.length; i++) {
  //               // check for duplicate trigger codes
  //               if (!foundTriggerCodes.includes(result.data[i].triggerCode)) {
  //                 let tempSetting = {
  //                   triggerName: result.data[i].ruleTitle,
  //                   triggerCode: result.data[i].triggerCode,
  //                   triggerCategory: result.data[i].Category,
  //                   customerTenants: result.data[i].Tenants,
  //                   description: result.data[i].Description,
  //                   action: {
  //                     messageTitle: result.data[i].ruleTitle,
  //                     actionType: 'Message',
  //                     messageText: result.data[i].providerMessage,
  //                     messagePriority: result.data[i].Priority
  //                   }
  //                 }
  //                 if (tempSetting.action.messagePriority === "") {
  //                   tempSetting.action.messagePriority = 'Normal';
  //                 } else if (tempSetting.action.messagePriority === "High") {
  //                   tempSetting.action.messagePriority = 'Critical';
  //                 }
  //                 csvArrayStructured.push(tempSetting);
  //                 foundTriggerCodes.push(result.data[i].triggerCode)
  //               }
  //             }
  //             let updatedAddedRuleCount = 0;
  //             for (let i = 0; i < csvArrayStructured.length; i++) {
  //               this.rules.filter(rule => {
  //                 if (csvArrayStructured[i].triggerCode === rule.triggerCode) csvArrayStructured[i]._id = rule._id
  //               })
  //               if (this.rules.filter(rule => csvArrayStructured[i].triggerCode === rule.triggerCode).length > 0) {
  //                 this._service.updateRule(csvArrayStructured[i]);
  //                 if (csvArrayStructured[i] && csvArrayStructured[i].triggerCode && csvArrayStructured[i].triggerCode !== '') {
  //                   updatedAddedRuleCount++;
  //                 }
  //                 this._service.getRules().then((rules: Rule[]) => this.rules = rules);
  //               } else {
  //                 this._service.addRule(csvArrayStructured[i]);
  //                 if (csvArrayStructured[i] && csvArrayStructured[i].triggerCode && csvArrayStructured[i].triggerCode !== '') {
  //                   updatedAddedRuleCount++;
  //                 }
  //                 this._service.getRules().then((rules: Rule[]) => this.rules = rules);
  //               }
  //               this._service.getRules().then((rules: Rule[]) => {
  //                 this.rules = rules;
  //                 this.updateList();
  //                 this.csvFileInputVariable.nativeElement.value = "";
  //               });

  //             }
  //             if(updatedAddedRuleCount > 0) {
  //               this.alertService.showTraditionalAlert("Import complete.")
  //             } else {
  //               this.alertService.showAlert("No records found in CSV!")
  //             }
  //           }
  //         }
  //       })
  //     }
  //   }
  //   this.updateList();
  // }


  async getAllRulesForExport() {
    this.exportAllData = []

    await this._org_service.getOrgGroupRules().then(res => {
      res.forEach((customRule: Rule) => {
        let defaultRule = this.rules.find(rule => rule.triggerCode == customRule.triggerCode)

        if (defaultRule === undefined) {
          const ruleValue = {
            'Client Name': customRule.org_name,
            'Client ID': customRule.org_id.split('/')[0],
            'Client Tenant': customRule.tenant_name || "",
            'Assigned Group': customRule.org_id,
            'Rule Name': customRule.triggerName,
            'Trigger Code': customRule.triggerCode,
            'State': customRule.state,
            'Message Title Default': "NO DEFAULT TITLE DEFINED IN RULE LIBRARY",
            'Message Title Client': customRule.action.messageTitle,
            'FD Message Default': "NO DEFAULT MESSAGE DEFINED IN RULE LIBRARY",
            'FD Message Client': customRule.action.messageText
          }
          this.exportAllData.push(ruleValue)
        } else {
          let ruleValue = {}
          try {
            ruleValue = {
              'Client Name': customRule.org_name,
              'Client ID': customRule.org_id.split('/')[0],
              'Client Tenant': customRule.tenant_name || "",
              'Assigned Group': customRule.org_id,
              'Rule Name': customRule.triggerName,
              'Trigger Code': customRule.triggerCode,
              'State': customRule.state,
              'Message Title Default': defaultRule.action.messageTitle,
              'Message Title Client': customRule.action.messageTitle,
              'FD Message Default': defaultRule.action.messageText,
              'FD Message Client': customRule.action.messageText
            }
          } catch(e) {
            try {
              // sometimes orgId is undefined, lets try without the org_id split
              ruleValue = {
                'Client Name': 'UNDEFINED',
                'Client ID': 'UNDEFINED',
                'Client Tenant': 'UNDEFINED',
                'Assigned Group': customRule.org_id,
                'Rule Name': customRule.triggerName,
                'Trigger Code': customRule.triggerCode,
                'State': customRule.state,
                'Message Title Default': defaultRule.action.messageTitle,
                'Message Title Client': customRule.action.messageTitle,
                'FD Message Default': defaultRule.action.messageText,
                'FD Message Client': customRule.action.messageText
              }
            } catch(e) {
              // if we error again, log it but do not break
              console.log(e)
            }
          }
          this.exportAllData.push(ruleValue)
        }
      })
    })
    return this.exportAllData
  }


  async exportAllRulesCsv() {
    this.generatingExport = true
    await this.getAllRulesForExport()
    this.generatingExport = false

    const options = {
      filename: 'all_rule_export_' + Date.now(),
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'rule_export',
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true
    };

    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(this.exportAllData)
  }

  showExportOptions() {
    this.requestedOidExport = null;
    this.enabledOptions = null;
    $("input:radio[name='enabledOptions']").each(function(i) {
      this.checked = false;
    });
    $(this._el.nativeElement).find('#exportOptionsDropdown').toggle('show');
  }

  async exportAllRulesCsvWithOptions() {
    if(!this.enabledOptions) {
      this.enabledOptions = 'null';
    }
    this.generatingExport = true
    await this.getAllRulesForExportWithOptions()
    this.generatingExport = false

    const options = {
      filename: 'all_rule_export_' + Date.now(),
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'rule_export',
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true
    };

    const csvExporter = new ExportToCsv(options);
    if(this.exportAllData && this.exportAllData.length > 0) {
      csvExporter.generateCsv(this.exportAllData);
      $(this._el.nativeElement).find('#exportOptionsDropdown').toggle();
    } else {
      this.alertService.showAlert("No results.  Please ensure the Org ID is valid.");
    }
  }

  async getAllRulesForExportWithOptions() {
    this.exportAllData = []
    let requestedOidExport = this.requestedOidExport;
    if (!requestedOidExport || requestedOidExport === 'null') {
      requestedOidExport = 'undefined';
    }
    await this._org_service.getOrgGroupRulesWithParams(this.enabledOptions, requestedOidExport).then(res => {
      res.forEach((customRule: Rule) => {
        let defaultRule = this.rules.find(rule => rule.triggerCode == customRule.triggerCode)

        if (defaultRule === undefined) {
          const ruleValue = {
            'Client Name': customRule.org_name,
            'Client ID': customRule.org_id.split('/')[0],
            'Client Tenant': customRule.tenant_name || "",
            'Assigned Group': customRule.org_id,
            'Rule Name': customRule.triggerName,
            'Trigger Code': customRule.triggerCode,
            'State': customRule.state,
            'Message Title Default': "NO DEFAULT TITLE DEFINED IN RULE LIBRARY",
            'Message Title Client': customRule.action.messageTitle,
            'FD Message Default': "NO DEFAULT MESSAGE DEFINED IN RULE LIBRARY",
            'FD Message Client': customRule.action.messageText
          }
          this.exportAllData.push(ruleValue)
        } else {
          let ruleValue = {}
          try {
            ruleValue = {
              'Client Name': customRule.org_name,
              'Client ID': customRule.org_id.split('/')[0],
              'Client Tenant': customRule.tenant_name || "",
              'Assigned Group': customRule.org_id,
              'Rule Name': customRule.triggerName,
              'Trigger Code': customRule.triggerCode,
              'State': customRule.state,
              'Message Title Default': defaultRule.action.messageTitle,
              'Message Title Client': customRule.action.messageTitle,
              'FD Message Default': defaultRule.action.messageText,
              'FD Message Client': customRule.action.messageText
            }
          } catch(e) {
            try {
              // sometimes orgId is undefined, lets try without the org_id split
              ruleValue = {
                'Client Name': 'UNDEFINED',
                'Client ID': 'UNDEFINED',
                'Client Tenant': 'UNDEFINED',
                'Assigned Group': customRule.org_id,
                'Rule Name': customRule.triggerName,
                'Trigger Code': customRule.triggerCode,
                'State': customRule.state,
                'Message Title Default': defaultRule.action.messageTitle,
                'Message Title Client': customRule.action.messageTitle,
                'FD Message Default': defaultRule.action.messageText,
                'FD Message Client': customRule.action.messageText
              }
            } catch(e) {
              // if we error again, log it but do not break
              console.log(e)
            }
          }
          this.exportAllData.push(ruleValue)
        }
      })
    })
    return this.exportAllData
  }
}
